import ArgonBox from 'component/Argon/ArgonBox';
import ArgonSelect from 'component/Argon/ArgonSelect';
import ArgonTypography from 'component/Argon/ArgonTypography';

import formUtil from 'utils/formUtil';

/**
 * @typedef {{value: string, lable: string}} ISelect
 *
 * @typedef IProps
 * @property {ISelect|undefined} value
 * @property {React.Dispatch<ISelect|undefined>} setValue
 *
 * @param {IProps} props
 */
function SelectPrefix({ value, setValue, ...rest }) {
  return (
    <>
      <ArgonBox mb={1} ml={0.5} lineHeight={0} display="inline-block">
        <ArgonTypography component="label" variant="caption" fontWeight="bold" textTransform="capitalize">
          คำนำหน้านาม
        </ArgonTypography>
      </ArgonBox>
      <ArgonSelect
        placeholder={'เลือก'}
        value={value}
        onChange={(v) => setValue(v)}
        options={formUtil.option.prefix}
        {...rest}
      />
    </>
  );
}

export default SelectPrefix;
